import { LoadingButton } from '@mui/lab'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from '@mui/material'
import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'

function EndorsementCloseRemark({
    open,
    setOpenDialog,
    updateQcStatus,
    loader
}) {
    const formik = useFormik({
        initialValues: {
            remark: '',
        },
        validationSchema: Yup.object({
            remark: Yup.string().trim().required('Enter the reason for closing the request is required'),
        }),
        onSubmit: (values) => {
            updateQcStatus('Closed', {
                remarks: values.remark,
                sendMail: false
            })
            handleClose()
        },
    })

    const handleClose = () => {
        setOpenDialog(false)
        formik.resetForm()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>Enter Remark</DialogTitle>

            <form onSubmit={formik.handleSubmit}>
                <DialogContent>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={
                            <>
                                {'Enter the reason for closing the request'}
                                <Typography component="span" sx={{ color: 'red' }}>
                                    {' '} *
                                </Typography>
                            </>
                        }
                        name="remark"
                        value={formik.values.remark}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.remark && Boolean(formik.errors.remark)}
                        helperText={formik.touched.remark && formik.errors.remark}
                    />
                </DialogContent>

                <DialogActions>


                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        loading={loader}
                    // disabled={!formik.isValid || !formik.dirty}
                    >
                        Submit
                    </LoadingButton>
                    <Button onClick={handleClose} variant="contained"
                        color="error">Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default EndorsementCloseRemark